/** 臻有钱_快速提现弹窗 曝光 */
export const TP_QUICK_WITHDRAW_CARD_SHOW = 'finance_loan_quickApplPop';
/** 臻有钱_快速提现弹窗 关闭 */
export const TP_QUICK_WITHDRAW_CARD_CLOSE = `${TP_QUICK_WITHDRAW_CARD_SHOW}_close`;
/** 臻有钱_快速提现弹窗_优惠券栏 曝光&点击 */
export const TP_QUICK_WITHDRAW_CARD_COUPON_CATEGORY = `${TP_QUICK_WITHDRAW_CARD_SHOW}_couponCategory`;
/** 臻有钱_快速提现弹窗_优惠券列表页 曝光&点击 */
export const TP_QUICK_WITHDRAW_CARD_COUPON = `${TP_QUICK_WITHDRAW_CARD_SHOW}_coupon`;
/** 臻有钱_快速提现弹窗_银行卡栏 曝光 */
export const TP_QUICK_WITHDRAW_CARD_CARD_CATEGORY = `${TP_QUICK_WITHDRAW_CARD_SHOW}_cardCategory`;
/** 臻有钱_快速提现弹窗_还款计划页面 曝光 */
export const TP_QUICK_WITHDRAW_CARD_REPAYMENT_TRAIL = `${TP_QUICK_WITHDRAW_CARD_SHOW}_repaymentTrail`;
/** 臻有钱_快速提现弹窗_其他信息页面 */
export const TP_QUICK_WITHDRAW_CARD_OTHER_INFO = `${TP_QUICK_WITHDRAW_CARD_SHOW}_otherInformation`;
/** 臻有钱_快速提现弹窗_其他信息页面_借款用途_借款用途详情页面 曝光&点击 */
export const TP_QUICK_WITHDRAW_CARD_LOAN_PURPOSE_DETAIL = `${TP_QUICK_WITHDRAW_CARD_SHOW}_otherInformation_lendPurpose_details`;
/** 臻有钱_快速提现弹窗_提现协议弹窗 曝光&点击  */
export const TP_QUICK_WITHDRAW_CARD_AGREEMENT_POP = `${TP_QUICK_WITHDRAW_CARD_SHOW}_withdrawalAgreement`;
/** 臻有钱_快速提现弹窗_提交申请 点击 */
export const TP_QUICK_WITHDRAW_CARD_SUBMIT = `${TP_QUICK_WITHDRAW_CARD_SHOW}_submit`;
/** 臻有钱_快速提现弹窗_去提现其他额度 点击 */
export const TP_QUICK_WITHDRAW_CARD_OTHER_AMOUNT = `${TP_QUICK_WITHDRAW_CARD_SHOW}_otherAmount`;

/** 臻有钱_快速提现弹窗_验证弹窗模块曝光 0 表示短信验证码， 1表示交易密码 */
export const TP_QUICK_WITHDRAW_CARD_VERIFICATION_POP = 'finance_loan_quickApplyPop_verificationPop';
